module.exports = __webpack_public_path__ + "img/sh.7375146.svg";